import { useContext, useState } from 'react';
import Image from 'next/image';
import classNames from 'classnames';
import { ReactSVG } from 'react-svg';
import { useTranslation } from 'next-i18next';
import { Button, ButtonsContainer, Modal, ThemeContext } from '@forma/forma-ui-kit';
import ClientWrap from '@/components/ClientWrap';
import Video from '@/components/Video';
import PageBlock from '@/components/PageBlock';
import RequestDemoModal2 from '@/components/blocks/RequestDemoModal2';
import RequestDemoModal3 from '@/components/blocks/RequestDemoModal3';
import { analytics } from '@/helpers/analytics';

import styles from './try-constructor-and-demo.module.css';

export const TryConstructorVideo = ({
  video,
  open,
  onClose,
  onOpen,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.videoWrap}>
      <Image
        src="/images/screen-filling.webp"
        className={styles.video}
        width={1146}
        height={577}
        alt=""
      />
      <div className={styles.videoOverlay}>
        <Button
          viewStyle="secondary"
          className={classNames(styles.button, styles.secondary, styles.playButton)}
          onClick={() => onOpen(true)}
          icon={<ReactSVG src="/icons/play-2.svg" className={styles.playIcon} />}
        >
          {t('watch_video')}
        </Button>
      </div>
      <ClientWrap>
        <Modal open={open} onClose={onClose} size="large">
          <Video
            className={styles.video}
            src={video}
          />
        </Modal>
      </ClientWrap>
    </div>
  );
};

const Buttons = ({ onClickRequest, onClickStart }) => {
  return (
    <ButtonsContainer className={styles.buttons}>
      <Button
        // as={Link}
        viewStyle="primary"
        className={styles.button}
        onClick={onClickStart}
      // href={`${lkUrl}/register?lng=${lang}`}
      >
        Начать бесплатно
      </Button>
      <Button
        // as={Link}
        viewStyle="secondary"
        className={classNames(styles.button, styles.secondary)}
        onClick={onClickRequest}
      // href="/request"
      >
        Запросить демо
      </Button>
    </ButtonsContainer>
  );
};

export const TryConstructorAndDemo = ({ video }) => {
  const { t } = useTranslation();
  const { viewport } = useContext(ThemeContext);
  const isPhone = ['phone', 'tabletS'].includes(viewport);
  const [isRequestOpen, setRequestOpen] = useState(false);
  const [isShowVideo, setShowVideo] = useState(false);
  const [isRequest3Open, setRequest3Open] = useState(false);

  return (
    <PageBlock className={styles.root} contentClassName={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>
          {t('fill_contracts_and_documents')}
        </div>
        <div className={styles.subtitle}>
          {t('create_contract_and_others')}
        </div>
        {!isPhone && (
          <Buttons
            onClickStart={() => setRequest3Open(true)}
            onClickRequest={() => {
              setRequestOpen(true);
              analytics.clickTryTrial();
            }}
          />
        )}
      </div>
      <TryConstructorVideo
        video={video}
        open={isShowVideo}
        onClose={() => setShowVideo(false)}
        onOpen={() => setShowVideo(true)}
      />
      {isPhone && (
        <Buttons
          onClickStart={() => setRequest3Open(true)}
          onClickRequest={() => {
            setRequestOpen(true);
            analytics.clickTryTrial();
          }}
        />
      )}

      <RequestDemoModal2
        open={isRequestOpen}
        onClose={setRequestOpen}
      />
      <RequestDemoModal3
        open={isRequest3Open}
        onClose={setRequest3Open}
      />
    </PageBlock>
  );
};
